import { useEffect, useState } from "react";
import Permit from "../util/permit";
import ManageOrgDuplicatesTab from "../components/modules/manageOrgDuplicatesTab";
import { TabContext, TabPanel } from "@mui/lab";
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { ResponsiveRow } from "../constants/layout.constants";
import ManageSystemOrganizationsTab from "../components/modules/manageSystemOrganizationsTab";

const ManageOrganizations = () => {
  const tabs = [
    { id: 0, name: "Manage Organization Duplicates", value: "manageOrgDuplicates" },
    { id: 1, name: "Manage System Organizations", value: "manageSysOrganizations" },
  ];

  const [value, setValue] = useState("manageOrgDuplicates");

  function populateTab(currentTab) {
    switch (currentTab) {
      case 0:
        return <ManageOrgDuplicatesTab />;
      case 1:
        return <ManageSystemOrganizationsTab />;
      default:
        return <ManageOrgDuplicatesTab />;
    }
  }

  function handleChange(e) {}

  useEffect(() => {
    setValue(tabs[0].value);
  }, []);

  return (
    <Permit
      roles="SYSAD,CS"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role  is not permitted to view this
            page. <br /> Please contact your system admin if you feel this is an error.
          </>
        ),
      }}
    >
      <ResponsiveRow
        container
        sx={{
          flexDirection: "column",
          flexWrap: "nowrap",

          width: "100%",
          height: "100%",

          backgroundColor: "#fff",
          borderRadius: "20px",
          boxShadow: "0 4px 5px 0 rgba(0,0,0,0.3)",

          padding: { xs: 0, lg: "20px" },
          overflowX: "auto",
        }}
      >
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{ marginTop: "20px" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabs.map((tab) => {
                return (
                  <Tab
                    key={tab.id}
                    label={tab.name}
                    id={tab.id}
                    value={tab.value}
                    aria-controls={`tabPanel-${value}`}
                    onClick={() => setValue(tab.value)}
                  />
                );
              })}
            </Tabs>
          </Box>
          {tabs.map((tab) => {
            return (
              <TabPanel
                key={tab.id}
                value={tab.value}
                index={tab.id}
                sx={{ padding: "10px" }}
              >
                {populateTab(tab.id)}
              </TabPanel>
            );
          })}
        </TabContext>
      </ResponsiveRow>
    </Permit>
  );
};

export default ManageOrganizations;
